// The flower beds along the street's grass verge (bg_street.webp), as foreground polygons in
// WORLD coordinates (the 8358×941 art scaled to 6395×720): whoever stands at the bottom of
// the walkable band (feet at STREET_FEET.frontY = 643) has her shoes behind the flowers, so
// each bed is re-drawn over her by sceneForeground.applyForeground. Top outlines traced on
// the art 2026-09-07 (topmost non-lawn pixel per column, every ~18 px); every polygon's base
// is the bottom of the picture, so a bed always sorts in front of anyone on the street.
// Pure: node --test checks the geometry.
const BOTTOM = 720;
const VERGE = 644;

// [x0, x1, [[x, topY], …]] per bed, left to right along the street.
const BEDS = [
  [0, 160, [[0, 624], [18, 602], [37, 617], [55, 605], [73, 595], [92, 599], [110, 620], [129, 616], [147, 634]]],
  [1050, 1445, [[1065, 621], [1083, 621], [1102, 642], [1120, 614], [1139, 614], [1157, 601], [1175, 617], [1194, 601], [1212, 599], [1230, 588],
    [1249, 598], [1267, 606], [1285, 613], [1304, 603], [1322, 606], [1341, 604], [1359, 592], [1377, 601], [1396, 619], [1414, 621], [1432, 633]]],
  [2340, 2730, [[2351, 623], [2369, 621], [2387, 636], [2406, 612], [2424, 613], [2442, 610], [2461, 614], [2479, 601], [2497, 602], [2516, 591],
    [2534, 618], [2553, 615], [2571, 611], [2589, 614], [2608, 605], [2626, 596], [2644, 591], [2663, 619], [2681, 613], [2699, 637], [2718, 642]]],
  [3625, 4000, [[3636, 619], [3654, 640], [3673, 618], [3691, 611], [3709, 608], [3728, 605], [3746, 604], [3765, 599], [3783, 591], [3801, 604],
    [3820, 602], [3838, 614], [3856, 603], [3875, 610], [3893, 596], [3911, 595], [3930, 599], [3948, 618], [3967, 617], [3985, 633]]],
  [4890, 5285, [[4903, 622], [4921, 621], [4940, 624], [4958, 612], [4976, 612], [4995, 601], [5013, 607], [5032, 601], [5050, 600], [5068, 588],
    [5087, 596], [5105, 605], [5123, 612], [5142, 601], [5160, 604], [5178, 608], [5197, 591], [5215, 600], [5234, 616], [5252, 621], [5270, 631]]],
  [6160, 6395, [[6170, 632], [6188, 620], [6207, 621], [6225, 630], [6244, 608], [6262, 614], [6280, 605], [6299, 608], [6317, 601], [6335, 601],
    [6354, 591], [6372, 604], [6390, 614]]],
];

/** Flat [x0,y0,x1,y1,…] polygons, one per bed: the traced top edge, then down the sides to the bottom. */
export const STREET_FLOWER_POLYS = BEDS.map(([x0, x1, top]) => [
  x0, VERGE, ...top.flat(), x1, VERGE, x1, BOTTOM, x0, BOTTOM,
]);
